import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';


const SweetAlert = ({ show, onHide, title, subtitle, icon, confirmButtonText, cancelButtonText, showCancelButton, onConfirm, onCancel, loadSubmit }) => {
    const showIcon = useMemo(() => {
        let iconClass = ''
        if (icon === 'delete') {
            iconClass = 'fa fa-trash text-danger'
        } else if (icon === 'shopping') {
            iconClass = 'fa fa-shopping-cart text-success'
        }
        return iconClass === '' ? '' : <i className={iconClass + ' fa-5x mt-4 mb-4'}></i>
    }, [icon])

    const renderButtons = useMemo(() => {
        let buttons = ''

        if (icon === 'delete') {
            buttons = <>
                <Button variant={`danger ${showCancelButton ? ' mr-2' : ''}`} onClick={onConfirm}>
                    {loadSubmit ? <i className="fa fa-circle-notch fa-spin"></i> : confirmButtonText}
                </Button>
                {showCancelButton ? <Button variant="dark" onClick={onCancel}>{cancelButtonText}</Button> : ''}
            </>
        } else if (icon === 'shopping') {
            buttons = <>
                {showCancelButton ? <Button variant="outline-dark mr-2" onClick={onCancel}>{cancelButtonText}</Button> : ''}
                <Button variant={`success ${showCancelButton ? ' mr-2' : ''}`} onClick={onConfirm}>
                    {loadSubmit ? <i className="fa fa-circle-notch fa-spin"></i> : confirmButtonText}
                </Button>
            </>
        }

        return buttons
    }, [icon, loadSubmit, showCancelButton, onConfirm, confirmButtonText])

    return <Modal show={show} onHide={onHide} backdrop="static" centered>
        <Modal.Body className="text-center">
            {showIcon}

            <div className="section-kicker mb-2">Confirmación</div>
            <h3><strong>{title}</strong></h3>
            <p className="text-muted">{subtitle}</p>
            <div className="mt-4">
                {renderButtons}
            </div>
        </Modal.Body>
    </Modal>
}

SweetAlert.defaultProps = {
    title: '',
    subtitle: '',
    icon: '',
    show: false,
    onHide: () => {},
    onConfirm: () => {},
    confirmButtonText: '',
    onCancel: () => {},
    cancelButtonText: '',
    showCancelButton: true,
    loadSubmit: false
}

export default SweetAlert;